import PermissionRoute from '@Src/_basic/helpers/PermissionRoute';
import { RouteConfig } from '@Src/app/BasicRouter';
import React, { memo } from 'react';
import AccountGroupManagementScreen from './screens/AccountGroupManagementScreen';

const routesConfig: RouteConfig[] = [
  {
    path: '/',
    element: <AccountGroupManagementScreen />,
  },
];

const AccountGroupManagementRouter = () => PermissionRoute(routesConfig);

export default memo(AccountGroupManagementRouter);
